<template>
  <details-development :info="infoDetails" />
  <div class="user-select">
    <span @click="viewControlAvatar">
      <i class="icon-nav-user"></i>
      <i class="icon-nav-bullet_down" />
    </span>
    <ul class="user-select__avatar-list" v-if="showMenuAvatar">
      <li class="is-header">
        MINHA CONTA
        <i class="icon-nav-bullet_up" />
      </li>
      <li class="is-subheader">{{ store.getters["user/user"].email }}</li>
      <li
        @click="toogleTheme"
        v-if="checkEnvironment"
        v-html="toggleLabel"
      ></li>
      <li v-if="checkEnvironment" @click="toGoLink('icons')">Ícones</li>
      <li v-if="checkEnvironment">
        <label for="switch1">Detalhes</label>
        <InputSwitch v-model="showDetailsDevelopment" inputId="switch1" />
      </li>
      <li v-if="checkEnvironment" @click="toGoStorybook">Storybook</li>
      <li v-if="featureFlag" @click="toGoLink('historical-consumption')">
        <i class="icon-nav-report"></i>
        Consumo de pacote
      </li>
      <li v-if="checkEnvironment" @click="refresh">Novo Code</li>
      <li @click="handleLogout">
        <i class="icon-nav-arrow_right" />
        Sair
      </li>
    </ul>
  </div>
  <div
    v-if="showMenuAvatar"
    class="user-select__wrapper"
    @click="hideViewAvatar"
  ></div>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import KeyCloak from "@/common/module/keyCloak";
import { infoDetails } from "./userSelect.details";

export default defineComponent({
  name: "UserSelect",

  setup() {
    const store = useStore();
    const router = useRouter();
    const showMenuAvatar = ref(false);

    const checkEnvironment = computed(() => {
      if (process.env.NODE_ENV !== "production") return true;

      return false;
    });

    const featureFlag = computed(() => {
      return KeyCloak.permissionPage("historical-consumption");
    });

    const toggleLabel = computed(() => {
      return store.getters["theme/active"] == "dark"
        ? "<i class='pi pi-sun'></i> Light Theme"
        : "<i class='pi pi-moon'></i> Dark Theme";
    });

    const avatar = computed(() => {
      return store.getters["user/user"].avatar
        ? store.getters["user/user"].avatar
        : require("@/assets/img/avatar.png");
    });

    const showDetailsDevelopment = computed({
      get() {
        return store.getters["user/showDetailsDevelopment"];
      },
      set(value) {
        store.dispatch("user/SET_DETAILS_DEVELOPMENT", value);
      },
    });

    const toogleTheme = () => {
      store.dispatch(
        "theme/SET_THEME",
        store.getters["theme/active"] == "light" ? "dark" : "light"
      );

      viewControlAvatar();
    };

    const viewControlAvatar = () => {
      showMenuAvatar.value = !showMenuAvatar.value;
    };

    const hideViewAvatar = () => {
      showMenuAvatar.value = false;
    };

    const handleLogout = () => {
      KeyCloak.redirectAuth();
    };

    const toGoLink = (name) => {
      router.push({ name });
      hideViewAvatar();
    };

    const toGoStorybook = () => {
      window.open("https://homol-storybook-xp.wake.tech", "_blank");
      hideViewAvatar();
    };

    const refresh = () => {
      KeyCloak.silentGetNewCode();
    };

    return {
      showMenuAvatar,
      avatar,
      checkEnvironment,
      viewControlAvatar,
      handleLogout,
      toogleTheme,
      toggleLabel,
      toGoLink,
      showDetailsDevelopment,
      infoDetails,
      featureFlag,
      hideViewAvatar,
      store,
      refresh,
      toGoStorybook,
    };
  },
});
</script>

<style lang="scss">
.user-select {
  position: relative;
  z-index: 1002;

  > span {
    display: flex;
    align-items: center;
    cursor: pointer;
    gap: 10px;

    > img {
      position: relative;
      z-index: 100;
      width: toRem(34px);
      height: auto;
    }

    i.icon-nav-user {
      background: #fff;
      width: 32px;
      height: 32px;
      border: 1.5px solid #d3d3d3;
      border-radius: 20px;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      // gap: 10px;
    }

    i {
      color: var(--insights-color-16);
      font-size: toRem(11px);
      z-index: 100;
    }
  }

  &__avatar-list {
    list-style: none;
    position: absolute;
    z-index: 1002;
    top: toRem(40px);
    right: 0;
    background: var(--insights-color-2);
    min-width: 160px;
    padding: toRem(17px) 0;
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
    border-radius: 4px;

    > li {
      margin: 0;
      color: #a3a3a3;
      cursor: pointer;
      align-items: center;
      display: flex;
      gap: 8px;
      text-wrap: nowrap;
      font-family: "text-medium";
      padding: toRem(2px) toRem(17px);

      i.icon-nav-report {
        font-size: toRem(14px);
      }

      &:hover:not(.is-header, .is-subheader) {
        color: var(--insights-color-1);
        background-color: var(--insights-color-13);
      }

      i {
        font-size: toRem(12px);
        margin-top: toRem(-4px);
      }

      &.is-header {
        font-family: "text-bold";
        display: flex;
        justify-content: space-between;
        cursor: auto;
        margin-bottom: 0;
        padding-bottom: 0;
        padding-top: 0;
      }

      &.is-subheader {
        cursor: auto;
        color: var(--insights-color-15);
        margin-bottom: toRem(15px);
        padding-bottom: 0;
        padding-top: 0;
      }
    }
  }

  &__wrapper {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1001;
  }
}
</style>
